import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "g-timeaxis" }
const _hoisted_2 = { class: "g-timeunits-container" }
const _hoisted_3 = { class: "g-timeunits-container" }
const _hoisted_4 = { style: {"text-align":"center"} }

import provideConfig from "../provider/provideConfig"
import useTimeaxisUnits from "../composables/useTimeaxisUnits"
import dayjs from "dayjs"
import { toRefs } from 'vue'
import { isWeekday } from '@/ganttastic/composables/useDayjsHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttTimeaxis',
  setup(__props) {

const { precision, colors } = toRefs(provideConfig())
const { timeaxisUnits } = useTimeaxisUnits()

const properDate = (value: string|Date)  => {
  return dayjs(new Date(value)).format("dd. D.M.")
}

const background = (index: number, date: string|Date) => {
  if (!isWeekday(dayjs(date))) return colors.value.weekend
  return index % 2 === 0 ? colors.value.ternary : colors.value.quartenary
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeaxisUnits).upperUnits, ({ label, value, date, width }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: label,
          class: "g-upper-timeunit",
          style: _normalizeStyle({
          background: index % 2 === 0 ? _unref(colors).primary : _unref(colors).secondary,
          color: _unref(colors).text,
          width
        })
        }, [
          _renderSlot(_ctx.$slots, "upper-timeunit", {
            label: label,
            value: value,
            date: date
          }, () => [
            _createTextVNode(_toDisplayString(label), 1)
          ])
        ], 4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeaxisUnits).lowerUnits, ({ label, value, date, width }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: label,
          class: "g-timeunit",
          style: _normalizeStyle({
          background: background(index, date),
          color: _unref(colors).text,
          flexDirection: _unref(precision) === 'hour' ? 'column' : 'row',
          alignItems: _unref(precision) === 'hour' ? '' : 'center',
          width
        })
        }, [
          _renderSlot(_ctx.$slots, "timeunit", {
            label: label,
            value: value,
            date: date
          }, () => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(properDate(value)), 1)
          ]),
          (_unref(precision) === 'hour')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "g-timeaxis-hour-pin",
                style: _normalizeStyle({ background: _unref(colors).text })
              }, null, 4))
            : _createCommentVNode("", true)
        ], 4))
      }), 128))
    ])
  ]))
}
}

})